import { CurecallCheckbox } from '@honestica/curecall-ui'
import { TPatient } from 'src/types/patient'
import { getTranslatedLabel } from 'src/utils/locale.util'
import { useTranslation } from 'react-i18next'
import { TNavigationLocales } from 'src/types/locales'
import { TDeprecatedPatientVariable } from 'src/types/variable'
import { useFollowupFormContext } from './generic-followup-form.component'

interface Props {
  updatePatientVariableList: (variableName: TDeprecatedPatientVariable, isChecked: boolean) => void
}

const GenericFollowupVariables = ({ updatePatientVariableList }: Props) => {
  const { i18n } = useTranslation()
  const locale = i18n.language as TNavigationLocales
  const { t } = useTranslation()
  const { configUI, patient } = useFollowupFormContext()
  const patientVariablesConfig = configUI?.patientVariables

  if (!patientVariablesConfig || patientVariablesConfig.length < 1) {
    return null
  }

  return (
    <div className="c-px-8 c-py-6">
      <h2 className="c-text-xl c-text-grey-700 c-font-bold c-mb-5">
        {t('components.generic-followups-form.additional-information')}
      </h2>
      <div className="c-flex c-gap-10">
        {patientVariablesConfig.map((patientVariable) => (
          <CurecallCheckbox
            label={getTranslatedLabel(locale, patientVariable.label)}
            name={patientVariable.variableName}
            key={patientVariable.variableName}
            onChange={(e) => {
              const isChecked = e.target.checked
              updatePatientVariableList(patientVariable, isChecked)
            }}
            tooltipContent={getTranslatedLabel(locale, patientVariable?.tooltipText)}
            isByDefaultChecked={!!patient?.[patientVariable.variableName as keyof TPatient]}
          />
        ))}
      </div>
    </div>
  )
}

export default GenericFollowupVariables
